import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Colors } from "@snapchat/snap-design-system";

export const breadcrumbContainer = css`
    padding-bottom: 8px;
`;

export const BreadcrumbItem = styled.span<{ active?: boolean }>`
    font-size: 12px;
    font-weight: ${({ active }) => (active ? 700 : 500)};
    line-height: 16px;
    color: ${Colors.Black.V50};
`;

export const BreadcrumbItemContainer = styled.div`
    overflow: hidden;
    max-width: 300px;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
